import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

import { ENTITY } from "../constants";
import { getCurrentMediaItem, resetCurrentMediaItem } from "../store/actions";

export function useCurrentMediaItemData(props) {
  const { propertyId, mediaItemId } = props;

  const dispatch = useDispatch();
  const timer = useRef(null);

  const fetchCurrentMediaItem = () => {
    if (mediaItemId) {
      if (timer.current) {
        clearTimeout(timer.current);
      }

      timer.current = setTimeout(() => {
        dispatch(getCurrentMediaItem(propertyId, mediaItemId));
      }, 300);
    } else {
      dispatch(resetCurrentMediaItem());
    }
  };

  useEffect(() => {
    fetchCurrentMediaItem();
  }, [propertyId, mediaItemId]);

  useEffect(() => {
    const listener = ({ detail }) => {
      const { instances, options = {} } = detail;

      if (instances.includes(+mediaItemId) || options.mediaItemId === +mediaItemId) {
        fetchCurrentMediaItem();
      }
    };

    const entities = [ENTITY.MEDIA_ITEM];

    entities.forEach((entity) => document.addEventListener(entity, listener));
    return () => entities.forEach((entity) => document.removeEventListener(entity, listener));
  }, [propertyId, mediaItemId]);
}
